module.exports = __webpack_public_path__ + "static/matiaswork8-e128e2d4e3a167140d6c080640dd88d5.jpg";